import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/LzfsAN5zHOJVgfw4V8QH",
    children: [
      {
        path: "",
        name: "levels",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Arms" : "levels",
          acc: ["v77"],
        },
        component: () => import("../views/level/index.vue"),
      },
      {
        path: "PgucwTjPTnmw20TR8aLHw",
        name: "assigned_levels",
        meta: {
          authRequired: true,
          title:
            appInfo?.type === "codsms" ? "Assigned arms" : "Asssigned Levels",
          acc: ["y31190"],
        },
        component: () => import("../views/level/assigned.vue"),
      },
      {
        path: "PgucwTjPTnmK3TR8aLHw",
        name: "new-level",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "New Arm" : "New level",
          acc: ["v25"],
        },
        component: () => import("../views/level/new.vue"),
      },
      {
        path: "PgucwTjPTnmK312k8rLHP",
        name: "assign_level",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Assign Arm" : "Assign level",
          acc: ["y48938"],
        },
        component: () => import("../views/level/assign.vue"),
      },
      {
        path: "bZu3dPLkswGWmGO7D7Dt/:level?",
        name: "level",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Arm" : "Level",
          acc: ["v52"],
        },
        component: () => import("../views/level/view.vue"),

        // children: [
        //   {
        //     path: "6c4576a3-5d3c-4ab7-aec5-0889daf5f355/:er?",
        //     name: "view-student",
        //     meta: {
        //       title: "View Student",
        //       authRequired: true,

        //     },
        //     component: () => import("@/views/students/view"),
        //   },

        // ]
      },
      {
        path: "bZu3dPLkswGWmGO7D7Dtaddqadadaxeqweeq/:level?",
        name: "edit-level",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Edit Arm" : "Edit Level",
          acc: ["v52"],
        },
        component: () => import("../views/level/edit.vue"),
      },
    ],
  },
];
